{
	"Subtype_Advisor": "Advisor",
	"Subtype_Aetherborn": "Aetherborn",
	"Subtype_Alien": "Alien",
	"Subtype_Ally": "Ally",
	"Subtype_Angel": "Angel",
	"Subtype_Antelope": "Antelope",
	"Subtype_Ape": "Ape",
	"Subtype_Archer": "Archer",
	"Subtype_Archon": "Archon",
	"Subtype_Army": "Army",
	"Subtype_Artificer": "Artificer",
	"Subtype_Assassin": "Assassin",
	"Subtype_Assembly-Worker": "Assembly-Worker",
	"Subtype_Astartes": "Astartes",
	"Subtype_Atog": "Atog",
	"Subtype_Aurochs": "Aurochs",
	"Subtype_Avatar": "Avatar",
	"Subtype_Azra": "Azra",
	"Subtype_Badger": "Badger",
	"Subtype_Balloon": "Balloon",
	"Subtype_Barbarian": "Barbarian",
	"Subtype_Bard": "Bard",
	"Subtype_Basilisk": "Basilisk",
	"Subtype_Bat": "Bat",
	"Subtype_Bear": "Bear",
	"Subtype_Beast": "Beast",
	"Subtype_Beeble": "Beeble",
	"Subtype_Beholder": "Beholder",
	"Subtype_Berserker": "Berserker",
	"Subtype_Bird": "Bird",
	"Subtype_Boar": "Boar",
	"Subtype_Bringer": "Bringer",
	"Subtype_Brushwagg": "Brushwagg",
	"Subtype_Camel": "Camel",
	"Subtype_Capybara": "Capybara",
	"Subtype_Carrier": "Carrier",
	"Subtype_Cat": "Cat",
	"Subtype_Centaur": "Centaur",
	"Subtype_Cephalid": "Cephalid",
	"Subtype_Child": "Child",
	"Subtype_Chimera": "Chimera",
	"Subtype_Citizen": "Citizen",
	"Subtype_Cleric": "Cleric",
	"Subtype_Clown": "Clown",
	"Subtype_Cockatrice": "Cockatrice",
	"Subtype_Construct": "Construct",
	"Subtype_Coward": "Coward",
	"Subtype_Crab": "Crab",
	"Subtype_Crocodile": "Crocodile",
	"Subtype_Custodes": "Custodes",
	"Subtype_Cyberman": "Cyberman",
	"Subtype_Cyclops": "Cyclops",
	"Subtype_Dalek": "Dalek",
	"Subtype_Dauthi": "Dauthi",
	"Subtype_Demigod": "Demigod",
	"Subtype_Demon": "Demon",
	"Subtype_Designer": "Designer",
	"Subtype_Detective": "Detective",
	"Subtype_Devil": "Devil",
	"Subtype_Dinosaur": "Dinosaur",
	"Subtype_Djinn": "Djinn",
	"Subtype_Doctor": "Doctor",
	"Subtype_Dog": "Dog",
	"Subtype_Dragon": "Dragon",
	"Subtype_Drake": "Drake",
	"Subtype_Dreadnought": "Dreadnought",
	"Subtype_Drone": "Drone",
	"Subtype_Druid": "Druid",
	"Subtype_Dryad": "Dryad",
	"Subtype_Dwarf": "Dwarf",
	"Subtype_Efreet": "Efreet",
	"Subtype_Egg": "Egg",
	"Subtype_Elder": "Elder",
	"Subtype_Eldrazi": "Eldrazi",
	"Subtype_Elemental": "Elemental",
	"Subtype_Elephant": "Elephant",
	"Subtype_Elf": "Elf",
	"Subtype_Elk": "Elk",
	"Subtype_Employee": "Employee",
	"Subtype_Eye": "Eye",
	"Subtype_Faerie": "Faerie",
	"Subtype_Ferret": "Ferret",
	"Subtype_Fish": "Fish",
	"Subtype_Flagbearer": "Flagbearer",
	"Subtype_Fox": "Fox",
	"Subtype_Fractal": "Fractal",
	"Subtype_Frog": "Frog",
	"Subtype_Fungus": "Fungus",
	"Subtype_Gamer": "Gamer",
	"Subtype_Gargoyle": "Gargoyle",
	"Subtype_Germ": "Germ",
	"Subtype_Giant": "Giant",
	"Subtype_Gith": "Gith",
	"Subtype_Gnoll": "Gnoll",
	"Subtype_Gnome": "Gnome",
	"Subtype_Goat": "Goat",
	"Subtype_Goblin": "Goblin",
	"Subtype_God": "God",
	"Subtype_Golem": "Golem",
	"Subtype_Gorgon": "Gorgon",
	"Subtype_Graveborn": "Graveborn",
	"Subtype_Gremlin": "Gremlin",
	"Subtype_Griffin": "Griffin",
	"Subtype_Guest": "Guest",
	"Subtype_Hag": "Hag",
	"Subtype_Halfling": "Halfling",
	"Subtype_Hamster": "Hamster",
	"Subtype_Harpy": "Harpy",
	"Subtype_Hellion": "Hellion",
	"Subtype_Hippo": "Hippo",
	"Subtype_Hippogriff": "Hippogriff",
	"Subtype_Homarid": "Homarid",
	"Subtype_Homunculus": "Homunculus",
	"Subtype_Horror": "Horror",
	"Subtype_Horse": "Horse",
	"Subtype_Human": "Human",
	"Subtype_Hydra": "Hydra",
	"Subtype_Hyena": "Hyena",
	"Subtype_Illusion": "Illusion",
	"Subtype_Imp": "Imp",
	"Subtype_Incarnation": "Incarnation",
	"Subtype_Inkling": "Inkling",
	"Subtype_Inquisitor": "Inquisitor",
	"Subtype_Insect": "Insect",
	"Subtype_Jackal": "Jackal",
	"Subtype_Jellyfish": "Jellyfish",
	"Subtype_Juggernaut": "Juggernaut",
	"Subtype_Kavu": "Kavu",
	"Subtype_Kirin": "Kirin",
	"Subtype_Kithkin": "Kithkin",
	"Subtype_Knight": "Knight",
	"Subtype_Kobold": "Kobold",
	"Subtype_Kor": "Kor",
	"Subtype_Kraken": "Kraken",
	"Subtype_Lamia": "Lamia",
	"Subtype_Lammasu": "Lammasu",
	"Subtype_Leech": "Leech",
	"Subtype_Leviathan": "Leviathan",
	"Subtype_Lhurgoyf": "Lhurgoyf",
	"Subtype_Licid": "Licid",
	"Subtype_Lizard": "Lizard",
	"Subtype_Manticore": "Manticore",
	"Subtype_Masticore": "Masticore",
	"Subtype_Mercenary": "Mercenary",
	"Subtype_Merfolk": "Merfolk",
	"Subtype_Metathran": "Metathran",
	"Subtype_Minion": "Minion",
	"Subtype_Minotaur": "Minotaur",
	"Subtype_Mite": "Mite",
	"Subtype_Mole": "Mole",
	"Subtype_Monger": "Monger",
	"Subtype_Mongoose": "Mongoose",
	"Subtype_Monk": "Monk",
	"Subtype_Monkey": "Monkey",
	"Subtype_Moonfolk": "Moonfolk",
	"Subtype_Mouse": "Mouse",
	"Subtype_Mutant": "Mutant",
	"Subtype_Myr": "Myr",
	"Subtype_Mystic": "Mystic",
	"Subtype_Naga": "Naga",
	"Subtype_Nautilus": "Nautilus",
	"Subtype_Necron": "Necron",
	"Subtype_Nephilim": "Nephilim",
	"Subtype_Nightmare": "Nightmare",
	"Subtype_Nightstalker": "Nightstalker",
	"Subtype_Ninja": "Ninja",
	"Subtype_Noble": "Noble",
	"Subtype_Noggle": "Noggle",
	"Subtype_Nomad": "Nomad",
	"Subtype_Nymph": "Nymph",
	"Subtype_Octopus": "Octopus",
	"Subtype_Ogre": "Ogre",
	"Subtype_Ooze": "Ooze",
	"Subtype_Orc": "Orc",
	"Subtype_Orgg": "Orgg",
	"Subtype_Otter": "Otter",
	"Subtype_Ouphe": "Ouphe",
	"Subtype_Ox": "Ox",
	"Subtype_Oyster": "Oyster",
	"Subtype_Pangolin": "Pangolin",
	"Subtype_Peasant": "Peasant",
	"Subtype_Pegasus": "Pegasus",
	"Subtype_Pentavite": "Pentavite",
	"Subtype_Performer": "Performer",
	"Subtype_Pest": "Pest",
	"Subtype_Phelddagrif": "Phelddagrif",
	"Subtype_Phoenix": "Phoenix",
	"Subtype_Phyrexian": "Phyrexian",
	"Subtype_Pilot": "Pilot",
	"Subtype_Pirate": "Pirate",
	"Subtype_Plant": "Plant",
	"Subtype_Praetor": "Praetor",
	"Subtype_Primarch": "Primarch",
	"Subtype_Processor": "Processor",
	"Subtype_Rabbit": "Rabbit",
	"Subtype_Raccoon": "Raccoon",
	"Subtype_Ranger": "Ranger",
	"Subtype_Rat": "Rat",
	"Subtype_Rebel": "Rebel",
	"Subtype_Reflection": "Reflection",
	"Subtype_Rhino": "Rhino",
	"Subtype_Rigger": "Rigger",
	"Subtype_Robot": "Robot",
	"Subtype_Rogue": "Rogue",
	"Subtype_Sable": "Sable",
	"Subtype_Salamander": "Salamander",
	"Subtype_Samurai": "Samurai",
	"Subtype_Sand": "Sand",
	"Subtype_Saproling": "Saproling",
	"Subtype_Satyr": "Satyr",
	"Subtype_Scarecrow": "Scarecrow",
	"Subtype_Scientist": "Scientist",
	"Subtype_Scion": "Scion",
	"Subtype_Scorpion": "Scorpion",
	"Subtype_Scout": "Scout",
	"Subtype_Sculpture": "Sculpture",
	"Subtype_Serf": "Serf",
	"Subtype_Serpent": "Serpent",
	"Subtype_Servo": "Servo",
	"Subtype_Shade": "Shade",
	"Subtype_Shaman": "Shaman",
	"Subtype_Shapeshifter": "Shapeshifter",
	"Subtype_Shark": "Shark",
	"Subtype_Sheep": "Sheep",
	"Subtype_Siren": "Siren",
	"Subtype_Skeleton": "Skeleton",
	"Subtype_Slith": "Slith",
	"Subtype_Sliver": "Sliver",
	"Subtype_Slug": "Slug",
	"Subtype_Snail": "Snail",
	"Subtype_Snake": "Snake",
	"Subtype_Soldier": "Soldier",
	"Subtype_Soltari": "Soltari",
	"Subtype_Spawn": "Spawn",
	"Subtype_Specter": "Specter",
	"Subtype_Spellshaper": "Spellshaper",
	"Subtype_Sphinx": "Sphinx",
	"Subtype_Spider": "Spider",
	"Subtype_Spike": "Spike",
	"Subtype_Spirit": "Spirit",
	"Subtype_Splinter": "Splinter",
	"Subtype_Sponge": "Sponge",
	"Subtype_Squid": "Squid",
	"Subtype_Squirrel": "Squirrel",
	"Subtype_Starfish": "Starfish",
	"Subtype_Surrakar": "Surrakar",
	"Subtype_Survivor": "Survivor",
	"Subtype_Tentacle": "Tentacle",
	"Subtype_Thalakos": "Thalakos",
	"Subtype_Thopter": "Thopter",
	"Subtype_Thrull": "Thrull",
	"Subtype_Tiefling": "Tiefling",
	"Subtype_Time Lord": "Time Lord",
	"Subtype_Treefolk": "Treefolk",
	"Subtype_Trilobite": "Trilobite",
	"Subtype_Triskelavite": "Triskelavite",
	"Subtype_Troll": "Troll",
	"Subtype_Turtle": "Turtle",
	"Subtype_Tyranid": "Tyranid",
	"Subtype_Unicorn": "Unicorn",
	"Subtype_Vampire": "Vampire",
	"Subtype_Vedalken": "Vedalken",
	"Subtype_Volver": "Volver",
	"Subtype_Wall": "Wall",
	"Subtype_Walrus": "Walrus",
	"Subtype_Warlock": "Warlock",
	"Subtype_Warrior": "Warrior",
	"Subtype_Weird": "Weird",
	"Subtype_Werewolf": "Werewolf",
	"Subtype_Whale": "Whale",
	"Subtype_Wizard": "Wizard",
	"Subtype_Wolf": "Wolf",
	"Subtype_Wolverine": "Wolverine",
	"Subtype_Wombat": "Wombat",
	"Subtype_Worm": "Worm",
	"Subtype_Wraith": "Wraith",
	"Subtype_Wurm": "Wurm",
	"Subtype_Yeti": "Yeti",
	"Subtype_Zombie": "Zombie",
	"Subtype_Zubera": "Zubera"
}